import { TrendUp, TrendDown } from "@phosphor-icons/react";
import { formatCompact, formatINR, formatPct } from "@/lib/format";

export function KpiCard({ label, value, sub, tone, testId, index = 0 }) {
  const color = tone === "profit" ? "text-emerald-600" : tone === "loss" ? "text-rose-600" : "text-slate-900";
  return (
    <div data-testid={testId} style={{ animationDelay: `${index * 40}ms` }}
      className="rise-in p-5 bg-white border border-slate-200 rounded-sm shadow-sm flex flex-col transition-transform duration-200 hover:-translate-y-0.5">
      <div className="text-xs font-medium text-slate-500 uppercase tracking-wide">{label}</div>
      <div className={`text-2xl lg:text-3xl font-bold mt-2 font-heading tabular ${color}`} title={typeof value === "string" ? value : undefined}>{value}</div>
      {sub && <div className="text-xs mt-2 text-slate-500 tabular">{sub}</div>}
    </div>
  );
}

export function KpiGrid({ calc, project }) {
  const profit = calc.profit >= 0;
  const unpriced = calc.itemCount - calc.pricedCount;
  const provisional = unpriced > 0 ? ` · provisional (${unpriced} unpriced)` : "";
  const cards = [
    { label: "Total Govt BOQ", value: formatCompact(calc.govtAmount), sub: formatINR(calc.govtAmount), testId: "kpi-govt-boq" },
    { label: `After ${project.default_deduction}% Below`, value: formatCompact(calc.revenue), sub: `Below Govt rate by ${formatINR(calc.deductionAmount)}`, testId: "kpi-after-deduction" },
    { label: "Estimated Expenditure", value: formatCompact(calc.expenditure), sub: formatINR(calc.expenditure), testId: "kpi-expenditure" },
    {
      label: "Expected Profit / Loss", value: formatCompact(calc.profit), tone: profit ? "profit" : "loss", testId: "kpi-profit",
      sub: <span className={`inline-flex items-center gap-1 font-semibold ${profit ? "text-emerald-600" : "text-rose-600"}`}>{profit ? <TrendUp size={14} weight="bold" /> : <TrendDown size={14} weight="bold" />}{profit ? "Profit" : "Loss"} · {formatINR(calc.profit)}{provisional}</span>,
    },
    { label: "Profit Margin", value: formatPct(calc.margin), tone: profit ? "profit" : "loss", sub: `on revenue after deduction${provisional}`, testId: "kpi-margin" },
    { label: `GST @ ${calc.gstRate}%`, value: formatCompact(calc.gst), sub: `CGST ${formatINR(calc.cgst)} · SGST ${formatINR(calc.sgst)}`, testId: "kpi-gst" },
    { label: "Revenue incl. GST", value: formatCompact(calc.revenueWithGst), sub: formatINR(calc.revenueWithGst), testId: "kpi-revenue-gst" },
    { label: "Items Priced", value: `${calc.pricedCount} / ${calc.itemCount}`, sub: calc.itemCount - calc.pricedCount ? `${calc.itemCount - calc.pricedCount} items still need market cost` : "All items have market cost", testId: "kpi-items-priced" },
  ];
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-4 lg:gap-5">
      {cards.map((c, i) => <KpiCard key={c.testId} {...c} index={i} />)}
    </div>
  );
}
